import {useReducer, useEffect} from 'react';
import {getCustomerLabels} from './endpoints.js';
import errorHandler from '../../../util/errorHandler.js';
import moment from 'moment';
import 'moment/locale/nl';
moment.locale('nl');

// Actions
const LOADED_DATA = 'LOADED_DATA';
const LOADING_DATA = 'LOADING_DATA';

export const initialState = {
    loading: null,
    customers: [],
};

export function reducer(state, action) {
    switch (action.type) {
        case LOADING_DATA:
            return {
                ...state,
                loading: _.get(state, 'loading', 0) + 1,
            };

        case LOADED_DATA:
            return {
                ...state,
                customers: action.response,
                loading: _.get(state, 'loading', 0) - 1,
            };

        default:
            return state;
    }
}

function loadingCustomers() {
    return {
        type: LOADING_DATA,
    };
}

function loadedCustomerLabels(response) {
    return {
        type: LOADED_DATA,
        response,
    };
}

export function loadCustomers(dispatch) {
    dispatch(loadingCustomers());

    getCustomerLabels()
        .then((response) => dispatch(loadedCustomerLabels(response.data)))
        .catch((e) => errorHandler(e.response.data, true));
}

function useCustomers() {
    const [state, dispatch] = useReducer(reducer, {...initialState});

    useEffect(() => {
        loadCustomers(dispatch);
    }, []);

    return {
        ...state,
        reload: () => loadCustomers(dispatch),
    };
}

export default useCustomers;
